import apiRequest from '../utils/apiRequest';
import { setInvertedTheme, unsetInvertedTheme } from './ui';

const fetchingBook = () => ({
  type: 'FETCHING_BOOK'
});

const bookNotFound = () => ({
  type: 'BOOK_NOT_FOUND'
});

const receiveBook = book => {
  if (book.ok !== false) {
    return {
      type: 'RECEIVE_BOOK',
      book
    };
  } else {
    return {
      type: 'BOOK_ERROR',
      book
    };
  }
};

const fetchBook = id => async dispatch => {
  if (!id) {
    return false;
  }

  dispatch(fetchingBook());
  const response = await apiRequest('wordpress', `bookdata/v1/books?id=${id}`);

  if (!response.theme) {
    return dispatch(bookNotFound());
  }

  if (response.theme.text_color === 'dark') {
    dispatch(setInvertedTheme());
  } else {
    dispatch(unsetInvertedTheme());
  }

  return dispatch(receiveBook(response));
};

export const fetchBookIfNeeded = id => (dispatch, getState) => {
  const { book } = getState().book;

  if (book !== null) return;

  return dispatch(fetchBook(id));
};



// WEBPACK FOOTER //
// ./src/actions/book.js